/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import { operationTypes } from './ChannelMappingDefType';
import * as Permission from "../util/Permission";

export default declareEntity({
    entity: "screens",
    graphQL: "Screen",
    dynamoPrefix: 'org',
    storageType: 'central',
    name: "Screens",
    parentRelation: "screens",
    writePermission: [
        Permission.PERM_EDIT_SCREEN,
    ],
    fields: (types) => { return {
        id: {
            name: "Screen ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        organisation: {
            name: "Organisation",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (parent) => {
                return parent['organisation_id'];
            },
            required: true
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
            hiddenCreate: true,
            defaultValue: (parent) => {
                if (parent) {
                    return parent['instance_id'];
                }
            },
        },
        channel: {
            name: "Application",
            type: "relation",
            to: () => types['channels'],
            defaultValue: (parent) => {
                return parent['channel_id'];
            },
            required: true,
            parent: true,
        },
        channelDef: {
            name: "Application Definition",
            type: "relation",
            to: () => types['channelDefs'],
            defaultValue: (parent) => {
                return parent['channelDef_id'];
            },
            filterable: true,
            required: true,
            hiddenCreate: true,
        },
        channelEntityDef: {
            name: "Application Entity Definition",
            type: "relation",
            to: () => types['channelEntityDefs'],
            defaultValue: (parent) => {
                return parent['channelEntityDef_id'];
            },
            required: true,
            filterable: true,
            hiddenCreate: true,
            relativeTo: ['channelDef'],
        },
        operation: {
            name: "Operation",
            type: "enum",
            values: operationTypes,
            filterable: true,
            defaultValue: (parent) => {
                if (parent && parent['operation']) {
                    return parent['operation'];
                } else {
                    return 'view';
                }
            },
        },
        subOperation: {
            name: "Sub operation",
            description: "Sub operation - if user is looking on a detail of item, we can name the sub operation. User can then change the view he is looking on.",
            type: "string",
            defaultValue: "",
        },
        content: {
            name: "Content",
            type: "object",
            defaultValue: {},
        },
        screenDef: {
            name: "Screen Definition",
            type: "relation",
            to: () => types['screenDefs'],
        },
        scenarioScreenDef: {
            name: "Screen Definition",
            type: "relation",
            to: () => types['scenarioScreenDefs'],
            relativeTo: ['scenarioDef'],
        },
        scenarioDef: {
            name: "Scenario Definition",
            type: "relation",
            to: () => types['scenarioDefs'],
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
        views: {
            type: 'oneToMany',
            to: types['views'],
            hasPaging: false,
            export: true,
            defaultValue: () => {
                return {};
            }
        },
        dataSources: {
            type: 'oneToMany',
            to: types['dataSources'],
            hasPaging: false,
            export: true,
            defaultValue: () => {
                return {};
            }
        },
        viewsWithData: {
            type: 'oneToMany',
            controllerFn: 'getViewsWithData',
            args: {
                data: {
                    type: "string"
                },
            },
            to: types['viewWithData'],
        }
    }; }
});
